// ADMIN group — admin/* + arena/* (design doc's G3). Every route here hangs
// off `adminRoute` (routes/guards.tsx): non-admins (including signed-out
// users) redirect to `/` before the placeholder mounts, parity with
// app/admin/layout.tsx:6 and app/arena/layout.tsx:7-8. "All pure client
// already; lowest risk, done in bulk" per FRONTEND_SPA_DESIGN.md §6, G3.
//
// OWNERSHIP: this file is the G3 porters' — add new admin/arena routes here,
// never in core.tsx/agents.tsx.
//
// Real routes (/admin, /admin/config, /admin/skills, /admin/users,
// /admin/chats/$id, /arena, /arena/new, /arena/$id, /admin/eval,
// /admin/eval/$id, /admin/eval/viewer, /admin/queries) live in their own
// files (routes/admin-*.tsx, routes/arena-*.tsx) and are re-exported into
// this group's array, same pattern as routes/core.tsx does for the two G1
// routes.
import { adminRoute } from './guards';
import { adminOverviewRoute } from './admin-overview';
import { adminConfigRoute } from './admin-config';
import { adminSkillsRoute } from './admin-skills';
import { adminUsersRoute } from './admin-users';
import { adminChatDetailRoute } from './admin-chat-detail';
import { adminEvalRoute } from './admin-eval';
import { adminEvalDetailRoute } from './admin-eval-detail';
import { adminEvalViewerRoute } from './admin-eval-viewer';
import { adminQueriesRoute } from './admin-queries';
import { arenaListRoute } from './arena-list';
import { arenaNewRoute } from './arena-new';
import { arenaDetailRoute } from './arena-detail';

export const adminRoutes = [
  adminOverviewRoute,
  adminChatDetailRoute,
  adminConfigRoute,
  adminEvalRoute,
  adminEvalDetailRoute,
  adminEvalViewerRoute,
  adminQueriesRoute,
  adminSkillsRoute,
  adminUsersRoute,

  arenaListRoute,
  arenaNewRoute,
  arenaDetailRoute,
];
